export default "__VITE_ASSET__YVX5NSHA__"